export enum OverlayBackground {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface OwnProps {
  background: OverlayBackground;
  className?: string;
  closeOnEscape?: boolean;
}

export interface StateProps {
  isAnyPopoverCurrentlyOpen: boolean;
}

export interface DispatchProps {
  onClose: () => void;
}

export interface AllProps extends OwnProps, StateProps, DispatchProps {}
